module.exports = __webpack_public_path__ + "static/media/logo.762a1f47.png";